// components/GlobalSnackbar.jsx
import React from "react";

import { useDispatch, useSelector } from "react-redux";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { hideNotification } from "../../store/features/notificationSlice";

const Alert = React.forwardRef(function Alert(props, ref) {
    return (
        <MuiAlert
            elevation={6}
            ref={ref}
            variant="filled"
            {...props}
        />
    );
});

const GlobalSnackbar = () => {
    const dispatch = useDispatch();
    const { open, message, severity, duration } = useSelector((state) => state.notificationStore);

    const handleClose = (_, reason) => {
        if (reason === "clickaway") return;
        dispatch(hideNotification());
    };

    return (
        <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={open}
            autoHideDuration={duration}
            onClose={handleClose}
        >
            <Alert
                onClose={handleClose}
                severity={severity}
                sx={{
                    maxHeight: 300,
                    maxWidth: 700,
                    width: "100%",
                    overflow: "auto",
                }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

export default GlobalSnackbar;
